import { DarkThemeColors } from "../definitions/constants";

export default class AppHelper {
    public static IsAzureEnv () {
        return process.env.VUE_APP_ENV == "azure"
    }
    public static GetColour (name: any) {
        var hash = 0;
        if (!name || name.length === 0) return hash
        for (var i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash)
          hash = hash & hash
        }
        var color = '#'
        for (var i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 255
          color += ('00' + value.toString(16)).substr(-2)
        }
        return color
      }
    public static GetInitials (name: any) {
        if (name) {
          const parts = name.split(' ')
        let initials = '';
        if (parts.length === 2) {
          initials = `${parts[0][0]}${parts[1][0]}`
        }
        else initials = name[0];
        return initials
        }
      }
    public static decimalCount(num: any) {
        const numStr = String(num);
        if (numStr.includes(".")) {
           return numStr.split(".")[1].length;
        };
        return 0;
    }
    public static removeDecimals(value: any){
       if (this.decimalCount(value) > 2 && value !== 0) {
         return Number(value.toFixed(2));
       }
       return value;
     }
     public static getListItemColorByDate(list: any){
      var groupedTimesheet: any[] = [];
      var colorFlag = 1;
      list.forEach((item: any) => {
        
        if (groupedTimesheet.length == 0) {
          groupedTimesheet.push(item);
        } else {
          if (groupedTimesheet.length >= 1) {
            if (item.Date?.getDate() != groupedTimesheet[groupedTimesheet.length - 1].Date?.getDate()) {
              
              groupedTimesheet = [];
              colorFlag++;
              if (colorFlag % 2 === 0) {
                (item as any).backgroundColor = DarkThemeColors.Gray;
              }
              groupedTimesheet.push(item);
            }
            else{
              if (colorFlag % 2 === 0) {
                (item as any).backgroundColor = DarkThemeColors.Gray;
              }
              groupedTimesheet.push(item);
            }
          } 
        }
      });
      return list;
     }
}
